const DEFAULT_API_BASE = "https://dancemap.be/DMadmin/api/index.php?route=";
export const API_BASE = process.env.REACT_APP_API_BASE || DEFAULT_API_BASE;

const buildRouteUrl = (endpoint, params) => {
  const query = params?.toString();
  const base = API_BASE.endsWith("=")
    ? `${API_BASE}${endpoint}`
    : `${API_BASE}${endpoint}`;
  if (query && query.length > 0) {
    return `${base}${base.includes("?") ? "&" : "?"}${query}`;
  }
  return base;
};

export const buildEntitiesUrl = ({
  layerIds = [],
  taxonomyCodes = [],
  q,
  bbox,
  perPage = 0,
  fields = "lite",
  format = "geojson",
  page,
  yearFrom,
  yearTo,
}) => {
  const params = new URLSearchParams();
  layerIds.forEach((id) => params.append("layer_ids[]", id));
  taxonomyCodes.forEach((code) => params.append("taxonomy_code[]", code));
  if (q) params.set("q", q);
  if (bbox) params.set("bbox", bbox.join(","));
  if (typeof yearFrom === "number" && Number.isFinite(yearFrom)) {
    params.set("year_from", yearFrom);
  }
  if (typeof yearTo === "number" && Number.isFinite(yearTo)) {
    params.set("year_to", yearTo);
  }
  params.set("taxonomy_mode", "or");
  params.set("fields", fields);
  params.set("format", format);
  params.set("per_page", perPage);
  if (page) params.set("page", page);
  return buildRouteUrl("entities", params);
};

export const fetchLayers = (signal, includeCounts = false) => {
  const url = includeCounts
    ? buildRouteUrl("layers", new URLSearchParams({ include_counts: "1" }))
    : buildRouteUrl("layers");
  return fetch(url, { signal }).then((r) => r.json());
};

export const fetchEntities = (url, signal) =>
  fetch(url, { signal }).then((r) => r.json());

export const fetchEntityDetail = (id, signal) =>
  fetch(
    buildRouteUrl(`entities/${id}`, new URLSearchParams({ fields: "full" })),
    { signal }
  ).then((r) => r.json());

export const fetchDateRange = (signal) =>
  fetch(buildRouteUrl("date-range"), { signal }).then((r) => r.json());
